import React from 'react';
import styled from 'styled-components'

const RemoveMarker = styled.div`
    background-color: #F8642C;
    color: #fff;
    border-radius: 5px;
    font-weight: bold;
    text-align: center;
    padding: 5px 10px;
    cursor: pointer;
`;

const SaveMarkers = styled.div`
    background-color: #408140;
    color: #fff;
    border-radius: 5px;
    font-weight: bold;
    text-align: center;
    padding: 5px 10px;
    cursor: pointer;
    margin-top: 30px;
`;

const GoBackButton = styled.div`
    background-color: rgb(57, 118, 170);
    color: #fff;
    border-radius: 5px;
    font-weight: bold;
    text-align: center;
    padding: 5px 10px;
    cursor: pointer;
    margin-top: 5px;
`;

const SidebarStyle = styled.div`
  width: 25vw;
  display: ${props => props.status ? "block" : "none"};
  overflow: scroll;
  color: rgb(119, 119, 119);
  background: linear-gradient(
    rgb(249, 248, 247),
    rgb(251, 250, 248) 46px,
    rgb(251, 251, 249) 120px,
    rgb(248, 247, 245) 35%,
    rgb(249, 248, 246)
  );
  @media (max-width: 768px) {
      width: 100%;
  }
`


const updateHash = highlight => {
  document.location.hash = `highlight-${highlight.id}`;
};

function Sidebar(props) {

  const { resetHighlights, saveHighlights, removeHighlight, goBack, highlights, sidebarStatus } = props
  return <SidebarStyle status={sidebarStatus}>
    <div className="description" style={{ padding: "1rem" }}>
      <h2 style={{ marginBottom: "1rem", marginTop: 50 }}>Comentários</h2>
      <p>
        <small>
          Selecione o trecho de texto para marcar ou segure a tecla Alt (Option para usuários de MAC) e arraste e clique com o mouse
      </small>
        <SaveMarkers onClick={saveHighlights}>Salvar grifos</SaveMarkers>
        <GoBackButton onClick={goBack}>Voltar</GoBackButton>
      </p>
    </div>

    <ul className="sidebar__highlights">
      {highlights.map((highlight, index) => (
        <li
          key={index}
          className="sidebar__highlight"
          onClick={() => {
            updateHash(highlight);
          }}
        >
          <div>
            <strong>{highlight.comment.text}</strong>
            {highlight.content.text ? (
              <blockquote style={{ marginTop: "0.5rem" }}>
                {`${highlight.content.text.slice(0, 90).trim()}…`}
              </blockquote>
            ) : null}
            {highlight.content.image ? (
              <div
                className="highlight__image"
                style={{ marginTop: "0.5rem" }}
              >
                <img src={highlight.content.image} alt={"Screenshot"} />
              </div>
            ) : null}
          </div>
          <div className="highlight__location">
            <RemoveMarker onClick={() => removeHighlight(highlight.id)}>Remover grifo</RemoveMarker>
            Página {highlight.position.pageNumber}
          </div>
        </li>
      ))}
    </ul>
    {highlights.length > 0 ? (
      <div style={{ padding: "1rem" }}>
        <RemoveMarker onClick={resetHighlights}>Remover todos os grifos</RemoveMarker>
      </div>
    ) : null}
  </SidebarStyle>;
}

export default Sidebar;